/** Mock supervisor dashboard metrics (SRS §3.13 FR61) — replace with API later. */

export type DashboardKpi = { label: string; value: string; hint: string };

export const dashboardKpis: DashboardKpi[] = [
  { label: 'Open tasks', value: '128', hint: 'Across all assigned workflows' },
  { label: 'SLA at risk', value: '14', hint: 'Within TTR window' },
  { label: 'Overdue', value: '6', hint: 'Past TTE — review escalations' },
  { label: 'Avg. stage duration', value: '3.2 d', hint: 'Rolling 30 days' },
];

export type WorkflowLoadRow = { workflow: string; active: number; overdue: number };

export const workflowLoad: WorkflowLoadRow[] = [
  { workflow: 'Standard prosecution advice', active: 42, overdue: 2 },
  { workflow: 'Civil review — contract', active: 31, overdue: 1 },
  { workflow: 'Advisory — human rights', active: 18, overdue: 3 },
];
